import { NgModule } from '@angular/core'

import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { AgentDetailsStore } from '@flowx/designer/modules/agent-builder/agent-builder/components/agent-editor/agent-details.store'
import { KnowledgeBaseStore } from '@flowx/designer/modules/agent-builder/components/knowledge-base/knowledge-base.store'
import { ConversationErrorEffects } from '@flowx/designer/modules/ai/conversation/conversation-error.effects'
import { ConversationEffects } from '@flowx/designer/modules/ai/conversation/conversation.effects'
import { conversationReducer } from '@flowx/designer/modules/ai/conversation/conversation.reducer'
import { conversationFeatureKey } from '@flowx/designer/modules/ai/store/ai.constants'
import { MEDIA_LIBRARY_API } from '@flowx/designer/modules/core/dictionary/media-library.dictionary'
// eslint-disable-next-line import/no-cycle
import { AiAnalystEffects } from '@flowx/designer/modules/new-ai/agents/analyst/store/analyst.effects'
import { AiArchitectEffects } from '@flowx/designer/modules/new-ai/agents/architect/store/architect.effects'
import { AiAssistantEffects } from '@flowx/designer/modules/new-ai/agents/assistant/store/assistant.effects'
import { AiAuditorEffects } from '@flowx/designer/modules/new-ai/agents/auditor/store/auditor.effects'
// eslint-disable-next-line import/no-cycle
import { AiCoordinatorEffects } from '@flowx/designer/modules/new-ai/agents/coordinator/store/coordinator.effects'
import { AiDesignerEffects } from '@flowx/designer/modules/new-ai/agents/designer/store/designer.effects'
import { AiDeveloperEffects } from '@flowx/designer/modules/new-ai/agents/developer/store/developer.effects'
import { AiInspectorEffects } from '@flowx/designer/modules/new-ai/agents/inspector/api/store/inspector.effects'
import { AiIntegratorEffects } from '@flowx/designer/modules/new-ai/agents/integrator/store/integrator.effects'
import { MediaLibraryPrivateApi } from '@flowx/designer/shared/api/media-library-private.api'
import { MediaLibraryService } from '@flowx/designer/shared/services/media-library.service'

import { AiEffects } from './ai.effects'
import { aiReducer } from './ai.reducer'
import { ConversationKeepDiscardBridgeEffects } from './conversation-keep-discard-bridge.effects'

export const aiFeatureKey = 'ai'

@NgModule({
  imports: [
    StoreModule.forFeature(aiFeatureKey, aiReducer),
    StoreModule.forFeature(conversationFeatureKey, conversationReducer),
    EffectsModule.forFeature(
      AiEffects,
      AiCoordinatorEffects,
      AiAnalystEffects,
      AiAssistantEffects,
      AiAuditorEffects,
      AiArchitectEffects,
      AiDesignerEffects,
      AiDeveloperEffects,
      AiIntegratorEffects,
      AiInspectorEffects,
      ConversationEffects,
      ConversationErrorEffects,
      ConversationKeepDiscardBridgeEffects
    ),
  ],
  providers: [
    { provide: MEDIA_LIBRARY_API, useClass: MediaLibraryPrivateApi },
    MediaLibraryService,
    AgentDetailsStore,
    KnowledgeBaseStore,
  ],
})
export class AiStoreModule {}
